// Hands a complete, self-contained HTML document to the browser's print flow:
// a new window when allowed, otherwise a hidden iframe. The document prints
// itself once loaded and needs no network access.

export const openPrintDocument = (html, { win = window, doc = document } = {}) => {
  const popup = win.open("", "_blank");

  if (popup && popup.document) {
    popup.document.open();
    popup.document.write(html);
    popup.document.close();
    return { target: "window" };
  }

  const iframe = doc.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.setAttribute("aria-hidden", "true");
  doc.body.appendChild(iframe);

  const { contentDocument, contentWindow } = iframe;
  if (!contentDocument || !contentWindow) {
    doc.body.removeChild(iframe);
    throw new Error("Print iframe not available");
  }

  contentDocument.open();
  contentDocument.write(html);
  contentDocument.close();

  contentWindow.addEventListener("afterprint", () => {
    setTimeout(() => {
      try {
        doc.body.removeChild(iframe);
      } catch (_error) {}
    }, 400);
  });

  return { target: "iframe" };
};
